// @generated by protobuf-ts 2.11.1 with parameter server_generic,client_generic,generate_dependencies
// @generated from protobuf file "devices/v1/service.proto" (package "devices.v1", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { DeviceDefaultProfileHistoryEntry } from "./devices.js";
import { DeviceDefaultProfile } from "./devices.js";
import { Timestamp } from "../../google/protobuf/timestamp.js";
import { DeviceDefaultProfilePeriod } from "./devices.js";
import { ControlSignalType } from "./devices.js";
import { DeviceErrorType } from "./devices.js";
import { CriticalityLevel } from "./common.js";
import { DeviceError } from "./devices.js";
import { Struct } from "../../google/protobuf/struct.js";
import { DeviceCommunicationProtocol } from "./devices.js";
import { StationBatteryModel } from "./devices.js";
import { ConnectorType } from "./common.js";
import { ConnectorModel } from "./devices.js";
import { EvseModel } from "./devices.js";
import { StationModel } from "./devices.js";
import { StationaryBattery } from "./devices.js";
import { DeploymentStatus } from "./common.js";
import { Connector } from "./devices.js";
import { Evse } from "./devices.js";
import { LocationFilter } from "./common.js";
import { Station } from "./devices.js";
import { Location } from "./common.js";
import { FieldMask } from "../../google/protobuf/field_mask.js";
import { PaginationResponse } from "../../common/v1/common.js";
import { SortOptions } from "./common.js";
import { PaginationRequest } from "../../common/v1/common.js";
import { DeviceFilter } from "./common.js";
import { HydrationOptions } from "./common.js";
import { Device } from "./devices.js";
import { DeviceType } from "./common.js";
// @generated message type with reflection information, may provide speed optimized methods
class CreateDeviceRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateDeviceRequest", [
            { no: 1, name: "type", kind: "enum", T: () => ["devices.v1.DeviceType", DeviceType, "DEVICE_TYPE_"] },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "serial_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.type = 0;
        message.name = "";
        message.displayName = "";
        message.serialNumber = "";
        message.externalId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.DeviceType type */ 1:
                    message.type = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string display_name */ 3:
                    message.displayName = reader.string();
                    break;
                case /* string serial_number */ 4:
                    message.serialNumber = reader.string();
                    break;
                case /* string external_id */ 5:
                    message.externalId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.DeviceType type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string display_name = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        /* string serial_number = 4; */
        if (message.serialNumber !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.serialNumber);
        /* string external_id = 5; */
        if (message.externalId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.externalId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateDeviceRequest
 */
export const CreateDeviceRequest = new CreateDeviceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDeviceResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateDeviceResponse", [
            { no: 1, name: "device", kind: "message", T: () => Device }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.Device device */ 1:
                    message.device = Device.internalBinaryRead(reader, reader.uint32(), options, message.device);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.Device device = 1; */
        if (message.device)
            Device.internalBinaryWrite(message.device, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateDeviceResponse
 */
export const CreateDeviceResponse = new CreateDeviceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeviceRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.GetDeviceRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.HydrationOptions hydration */ 2:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.HydrationOptions hydration = 2; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetDeviceRequest
 */
export const GetDeviceRequest = new GetDeviceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeviceResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.GetDeviceResponse", [
            { no: 1, name: "device", kind: "message", T: () => Device }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.Device device */ 1:
                    message.device = Device.internalBinaryRead(reader, reader.uint32(), options, message.device);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.Device device = 1; */
        if (message.device)
            Device.internalBinaryWrite(message.device, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetDeviceResponse
 */
export const GetDeviceResponse = new GetDeviceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDevicesRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.ListDevicesRequest", [
            { no: 1, name: "filter", kind: "message", T: () => DeviceFilter },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 3, name: "sort", kind: "message", T: () => SortOptions },
            { no: 4, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.DeviceFilter filter */ 1:
                    message.filter = DeviceFilter.internalBinaryRead(reader, reader.uint32(), options, message.filter);
                    break;
                case /* common.v1.PaginationRequest pagination */ 2:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* devices.v1.SortOptions sort */ 3:
                    message.sort = SortOptions.internalBinaryRead(reader, reader.uint32(), options, message.sort);
                    break;
                case /* devices.v1.HydrationOptions hydration */ 4:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.DeviceFilter filter = 1; */
        if (message.filter)
            DeviceFilter.internalBinaryWrite(message.filter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationRequest pagination = 2; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.SortOptions sort = 3; */
        if (message.sort)
            SortOptions.internalBinaryWrite(message.sort, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.HydrationOptions hydration = 4; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListDevicesRequest
 */
export const ListDevicesRequest = new ListDevicesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDevicesResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.ListDevicesResponse", [
            { no: 1, name: "devices", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Device },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.devices = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated devices.v1.Device devices */ 1:
                    message.devices.push(Device.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated devices.v1.Device devices = 1; */
        for (let i = 0; i < message.devices.length; i++)
            Device.internalBinaryWrite(message.devices[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListDevicesResponse
 */
export const ListDevicesResponse = new ListDevicesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDeviceRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateDeviceRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "device", kind: "message", T: () => Device },
            { no: 3, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.Device device */ 2:
                    message.device = Device.internalBinaryRead(reader, reader.uint32(), options, message.device);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 3:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.Device device = 2; */
        if (message.device)
            Device.internalBinaryWrite(message.device, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 3; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateDeviceRequest
 */
export const UpdateDeviceRequest = new UpdateDeviceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDeviceResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateDeviceResponse", [
            { no: 1, name: "device", kind: "message", T: () => Device }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.Device device */ 1:
                    message.device = Device.internalBinaryRead(reader, reader.uint32(), options, message.device);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.Device device = 1; */
        if (message.device)
            Device.internalBinaryWrite(message.device, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateDeviceResponse
 */
export const UpdateDeviceResponse = new UpdateDeviceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDeviceRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteDeviceRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "permanent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.permanent = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bool permanent */ 2:
                    message.permanent = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bool permanent = 2; */
        if (message.permanent !== false)
            writer.tag(2, WireType.Varint).bool(message.permanent);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteDeviceRequest
 */
export const DeleteDeviceRequest = new DeleteDeviceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDeviceResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteDeviceResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteDeviceResponse
 */
export const DeleteDeviceResponse = new DeleteDeviceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RestoreDeviceRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.RestoreDeviceRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.RestoreDeviceRequest
 */
export const RestoreDeviceRequest = new RestoreDeviceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RestoreDeviceResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.RestoreDeviceResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.RestoreDeviceResponse
 */
export const RestoreDeviceResponse = new RestoreDeviceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateStationRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateStationRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "serial_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "location", kind: "message", T: () => Location },
            { no: 8, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "electric_supply", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        message.displayName = "";
        message.serialNumber = "";
        message.externalId = "";
        message.modelId = "";
        message.electricSupply = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string serial_number */ 3:
                    message.serialNumber = reader.string();
                    break;
                case /* string external_id */ 4:
                    message.externalId = reader.string();
                    break;
                case /* devices.v1.Location location */ 7:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* string model_id */ 8:
                    message.modelId = reader.string();
                    break;
                case /* double electric_supply */ 9:
                    message.electricSupply = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string serial_number = 3; */
        if (message.serialNumber !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.serialNumber);
        /* string external_id = 4; */
        if (message.externalId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.externalId);
        /* devices.v1.Location location = 7; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string model_id = 8; */
        if (message.modelId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.modelId);
        /* double electric_supply = 9; */
        if (message.electricSupply !== 0)
            writer.tag(9, WireType.Bit64).double(message.electricSupply);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateStationRequest
 */
export const CreateStationRequest = new CreateStationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateStationResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateStationResponse", [
            { no: 1, name: "station", kind: "message", T: () => Station }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.Station station */ 1:
                    message.station = Station.internalBinaryRead(reader, reader.uint32(), options, message.station);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.Station station = 1; */
        if (message.station)
            Station.internalBinaryWrite(message.station, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateStationResponse
 */
export const CreateStationResponse = new CreateStationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStationRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.GetStationRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.HydrationOptions hydration */ 2:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.HydrationOptions hydration = 2; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetStationRequest
 */
export const GetStationRequest = new GetStationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStationResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.GetStationResponse", [
            { no: 1, name: "station", kind: "message", T: () => Station }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.Station station */ 1:
                    message.station = Station.internalBinaryRead(reader, reader.uint32(), options, message.station);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.Station station = 1; */
        if (message.station)
            Station.internalBinaryWrite(message.station, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetStationResponse
 */
export const GetStationResponse = new GetStationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListStationsRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.ListStationsRequest", [
            { no: 1, name: "device_filter", kind: "message", T: () => DeviceFilter },
            { no: 2, name: "location_filter", kind: "message", T: () => LocationFilter },
            { no: 3, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 4, name: "sort", kind: "message", T: () => SortOptions },
            { no: 5, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.DeviceFilter device_filter */ 1:
                    message.deviceFilter = DeviceFilter.internalBinaryRead(reader, reader.uint32(), options, message.deviceFilter);
                    break;
                case /* devices.v1.LocationFilter location_filter */ 2:
                    message.locationFilter = LocationFilter.internalBinaryRead(reader, reader.uint32(), options, message.locationFilter);
                    break;
                case /* common.v1.PaginationRequest pagination */ 3:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* devices.v1.SortOptions sort */ 4:
                    message.sort = SortOptions.internalBinaryRead(reader, reader.uint32(), options, message.sort);
                    break;
                case /* devices.v1.HydrationOptions hydration */ 5:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.DeviceFilter device_filter = 1; */
        if (message.deviceFilter)
            DeviceFilter.internalBinaryWrite(message.deviceFilter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.LocationFilter location_filter = 2; */
        if (message.locationFilter)
            LocationFilter.internalBinaryWrite(message.locationFilter, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationRequest pagination = 3; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.SortOptions sort = 4; */
        if (message.sort)
            SortOptions.internalBinaryWrite(message.sort, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.HydrationOptions hydration = 5; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListStationsRequest
 */
export const ListStationsRequest = new ListStationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListStationsResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.ListStationsResponse", [
            { no: 1, name: "stations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Station },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.stations = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated devices.v1.Station stations */ 1:
                    message.stations.push(Station.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated devices.v1.Station stations = 1; */
        for (let i = 0; i < message.stations.length; i++)
            Station.internalBinaryWrite(message.stations[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListStationsResponse
 */
export const ListStationsResponse = new ListStationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateStationRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateStationRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "station", kind: "message", T: () => Station },
            { no: 3, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.Station station */ 2:
                    message.station = Station.internalBinaryRead(reader, reader.uint32(), options, message.station);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 3:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.Station station = 2; */
        if (message.station)
            Station.internalBinaryWrite(message.station, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 3; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateStationRequest
 */
export const UpdateStationRequest = new UpdateStationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateStationResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateStationResponse", [
            { no: 1, name: "station", kind: "message", T: () => Station }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.Station station */ 1:
                    message.station = Station.internalBinaryRead(reader, reader.uint32(), options, message.station);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.Station station = 1; */
        if (message.station)
            Station.internalBinaryWrite(message.station, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateStationResponse
 */
export const UpdateStationResponse = new UpdateStationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteStationRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteStationRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "permanent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.permanent = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bool permanent */ 2:
                    message.permanent = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bool permanent = 2; */
        if (message.permanent !== false)
            writer.tag(2, WireType.Varint).bool(message.permanent);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteStationRequest
 */
export const DeleteStationRequest = new DeleteStationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteStationResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteStationResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteStationResponse
 */
export const DeleteStationResponse = new DeleteStationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateEvseRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateEvseRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "serial_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "station_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "evse_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "permission_to_discharge", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        message.displayName = "";
        message.serialNumber = "";
        message.externalId = "";
        message.stationId = "";
        message.evseNumber = 0;
        message.permissionToDischarge = false;
        message.modelId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string serial_number */ 3:
                    message.serialNumber = reader.string();
                    break;
                case /* string external_id */ 4:
                    message.externalId = reader.string();
                    break;
                case /* string station_id */ 6:
                    message.stationId = reader.string();
                    break;
                case /* int32 evse_number */ 7:
                    message.evseNumber = reader.int32();
                    break;
                case /* bool permission_to_discharge */ 8:
                    message.permissionToDischarge = reader.bool();
                    break;
                case /* string model_id */ 9:
                    message.modelId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string serial_number = 3; */
        if (message.serialNumber !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.serialNumber);
        /* string external_id = 4; */
        if (message.externalId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.externalId);
        /* string station_id = 6; */
        if (message.stationId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.stationId);
        /* int32 evse_number = 7; */
        if (message.evseNumber !== 0)
            writer.tag(7, WireType.Varint).int32(message.evseNumber);
        /* bool permission_to_discharge = 8; */
        if (message.permissionToDischarge !== false)
            writer.tag(8, WireType.Varint).bool(message.permissionToDischarge);
        /* string model_id = 9; */
        if (message.modelId !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.modelId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateEvseRequest
 */
export const CreateEvseRequest = new CreateEvseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateEvseResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateEvseResponse", [
            { no: 1, name: "evse", kind: "message", T: () => Evse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.Evse evse */ 1:
                    message.evse = Evse.internalBinaryRead(reader, reader.uint32(), options, message.evse);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.Evse evse = 1; */
        if (message.evse)
            Evse.internalBinaryWrite(message.evse, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateEvseResponse
 */
export const CreateEvseResponse = new CreateEvseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetEvseRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.GetEvseRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.HydrationOptions hydration */ 2:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.HydrationOptions hydration = 2; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetEvseRequest
 */
export const GetEvseRequest = new GetEvseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetEvseResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.GetEvseResponse", [
            { no: 1, name: "evse", kind: "message", T: () => Evse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.Evse evse */ 1:
                    message.evse = Evse.internalBinaryRead(reader, reader.uint32(), options, message.evse);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.Evse evse = 1; */
        if (message.evse)
            Evse.internalBinaryWrite(message.evse, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetEvseResponse
 */
export const GetEvseResponse = new GetEvseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListEvsesRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.ListEvsesRequest", [
            { no: 1, name: "device_filter", kind: "message", T: () => DeviceFilter },
            { no: 2, name: "station_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 4, name: "sort", kind: "message", T: () => SortOptions },
            { no: 5, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.stationId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.DeviceFilter device_filter */ 1:
                    message.deviceFilter = DeviceFilter.internalBinaryRead(reader, reader.uint32(), options, message.deviceFilter);
                    break;
                case /* string station_id */ 2:
                    message.stationId = reader.string();
                    break;
                case /* common.v1.PaginationRequest pagination */ 3:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* devices.v1.SortOptions sort */ 4:
                    message.sort = SortOptions.internalBinaryRead(reader, reader.uint32(), options, message.sort);
                    break;
                case /* devices.v1.HydrationOptions hydration */ 5:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.DeviceFilter device_filter = 1; */
        if (message.deviceFilter)
            DeviceFilter.internalBinaryWrite(message.deviceFilter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string station_id = 2; */
        if (message.stationId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.stationId);
        /* common.v1.PaginationRequest pagination = 3; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.SortOptions sort = 4; */
        if (message.sort)
            SortOptions.internalBinaryWrite(message.sort, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.HydrationOptions hydration = 5; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListEvsesRequest
 */
export const ListEvsesRequest = new ListEvsesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListEvsesResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.ListEvsesResponse", [
            { no: 1, name: "evses", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Evse },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.evses = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated devices.v1.Evse evses */ 1:
                    message.evses.push(Evse.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated devices.v1.Evse evses = 1; */
        for (let i = 0; i < message.evses.length; i++)
            Evse.internalBinaryWrite(message.evses[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListEvsesResponse
 */
export const ListEvsesResponse = new ListEvsesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateEvseRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateEvseRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "evse", kind: "message", T: () => Evse },
            { no: 3, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.Evse evse */ 2:
                    message.evse = Evse.internalBinaryRead(reader, reader.uint32(), options, message.evse);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 3:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.Evse evse = 2; */
        if (message.evse)
            Evse.internalBinaryWrite(message.evse, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 3; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateEvseRequest
 */
export const UpdateEvseRequest = new UpdateEvseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateEvseResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateEvseResponse", [
            { no: 1, name: "evse", kind: "message", T: () => Evse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.Evse evse */ 1:
                    message.evse = Evse.internalBinaryRead(reader, reader.uint32(), options, message.evse);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.Evse evse = 1; */
        if (message.evse)
            Evse.internalBinaryWrite(message.evse, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateEvseResponse
 */
export const UpdateEvseResponse = new UpdateEvseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteEvseRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteEvseRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "permanent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.permanent = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bool permanent */ 2:
                    message.permanent = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bool permanent = 2; */
        if (message.permanent !== false)
            writer.tag(2, WireType.Varint).bool(message.permanent);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteEvseRequest
 */
export const DeleteEvseRequest = new DeleteEvseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteEvseResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteEvseResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteEvseResponse
 */
export const DeleteEvseResponse = new DeleteEvseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateConnectorRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateConnectorRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "serial_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "evse_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "connector_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        message.displayName = "";
        message.serialNumber = "";
        message.externalId = "";
        message.evseId = "";
        message.connectorNumber = 0;
        message.modelId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string serial_number */ 3:
                    message.serialNumber = reader.string();
                    break;
                case /* string external_id */ 4:
                    message.externalId = reader.string();
                    break;
                case /* string evse_id */ 6:
                    message.evseId = reader.string();
                    break;
                case /* int32 connector_number */ 7:
                    message.connectorNumber = reader.int32();
                    break;
                case /* string model_id */ 8:
                    message.modelId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string serial_number = 3; */
        if (message.serialNumber !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.serialNumber);
        /* string external_id = 4; */
        if (message.externalId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.externalId);
        /* string evse_id = 6; */
        if (message.evseId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.evseId);
        /* int32 connector_number = 7; */
        if (message.connectorNumber !== 0)
            writer.tag(7, WireType.Varint).int32(message.connectorNumber);
        /* string model_id = 8; */
        if (message.modelId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.modelId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateConnectorRequest
 */
export const CreateConnectorRequest = new CreateConnectorRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateConnectorResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateConnectorResponse", [
            { no: 1, name: "connector", kind: "message", T: () => Connector }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.Connector connector */ 1:
                    message.connector = Connector.internalBinaryRead(reader, reader.uint32(), options, message.connector);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.Connector connector = 1; */
        if (message.connector)
            Connector.internalBinaryWrite(message.connector, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateConnectorResponse
 */
export const CreateConnectorResponse = new CreateConnectorResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.GetConnectorRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.HydrationOptions hydration */ 2:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.HydrationOptions hydration = 2; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetConnectorRequest
 */
export const GetConnectorRequest = new GetConnectorRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.GetConnectorResponse", [
            { no: 1, name: "connector", kind: "message", T: () => Connector }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.Connector connector */ 1:
                    message.connector = Connector.internalBinaryRead(reader, reader.uint32(), options, message.connector);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.Connector connector = 1; */
        if (message.connector)
            Connector.internalBinaryWrite(message.connector, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetConnectorResponse
 */
export const GetConnectorResponse = new GetConnectorResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListConnectorsRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.ListConnectorsRequest", [
            { no: 1, name: "device_filter", kind: "message", T: () => DeviceFilter },
            { no: 2, name: "evse_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 4, name: "sort", kind: "message", T: () => SortOptions },
            { no: 5, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.evseId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.DeviceFilter device_filter */ 1:
                    message.deviceFilter = DeviceFilter.internalBinaryRead(reader, reader.uint32(), options, message.deviceFilter);
                    break;
                case /* string evse_id */ 2:
                    message.evseId = reader.string();
                    break;
                case /* common.v1.PaginationRequest pagination */ 3:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* devices.v1.SortOptions sort */ 4:
                    message.sort = SortOptions.internalBinaryRead(reader, reader.uint32(), options, message.sort);
                    break;
                case /* devices.v1.HydrationOptions hydration */ 5:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.DeviceFilter device_filter = 1; */
        if (message.deviceFilter)
            DeviceFilter.internalBinaryWrite(message.deviceFilter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string evse_id = 2; */
        if (message.evseId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.evseId);
        /* common.v1.PaginationRequest pagination = 3; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.SortOptions sort = 4; */
        if (message.sort)
            SortOptions.internalBinaryWrite(message.sort, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.HydrationOptions hydration = 5; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListConnectorsRequest
 */
export const ListConnectorsRequest = new ListConnectorsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListConnectorsResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.ListConnectorsResponse", [
            { no: 1, name: "connectors", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Connector },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.connectors = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated devices.v1.Connector connectors */ 1:
                    message.connectors.push(Connector.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated devices.v1.Connector connectors = 1; */
        for (let i = 0; i < message.connectors.length; i++)
            Connector.internalBinaryWrite(message.connectors[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListConnectorsResponse
 */
export const ListConnectorsResponse = new ListConnectorsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateConnectorRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateConnectorRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connector", kind: "message", T: () => Connector },
            { no: 3, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.Connector connector */ 2:
                    message.connector = Connector.internalBinaryRead(reader, reader.uint32(), options, message.connector);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 3:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.Connector connector = 2; */
        if (message.connector)
            Connector.internalBinaryWrite(message.connector, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 3; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateConnectorRequest
 */
export const UpdateConnectorRequest = new UpdateConnectorRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateConnectorResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateConnectorResponse", [
            { no: 1, name: "connector", kind: "message", T: () => Connector }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.Connector connector */ 1:
                    message.connector = Connector.internalBinaryRead(reader, reader.uint32(), options, message.connector);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.Connector connector = 1; */
        if (message.connector)
            Connector.internalBinaryWrite(message.connector, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateConnectorResponse
 */
export const UpdateConnectorResponse = new UpdateConnectorResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteConnectorRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteConnectorRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "permanent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.permanent = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bool permanent */ 2:
                    message.permanent = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bool permanent = 2; */
        if (message.permanent !== false)
            writer.tag(2, WireType.Varint).bool(message.permanent);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteConnectorRequest
 */
export const DeleteConnectorRequest = new DeleteConnectorRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteConnectorResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteConnectorResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteConnectorResponse
 */
export const DeleteConnectorResponse = new DeleteConnectorResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateStationaryBatteryRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateStationaryBatteryRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "serial_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "external_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "deployment_status", kind: "enum", T: () => ["devices.v1.DeploymentStatus", DeploymentStatus, "DEPLOYMENT_STATUS_"] },
            { no: 7, name: "site_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "usable_capacity_wh", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "capacity_measured_at", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        message.displayName = "";
        message.serialNumber = "";
        message.externalId = "";
        message.deploymentStatus = 0;
        message.siteId = "";
        message.modelId = "";
        message.capacityMeasuredAt = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string serial_number */ 3:
                    message.serialNumber = reader.string();
                    break;
                case /* string external_id */ 4:
                    message.externalId = reader.string();
                    break;
                case /* devices.v1.DeploymentStatus deployment_status */ 6:
                    message.deploymentStatus = reader.int32();
                    break;
                case /* string site_id */ 7:
                    message.siteId = reader.string();
                    break;
                case /* string model_id */ 8:
                    message.modelId = reader.string();
                    break;
                case /* optional double usable_capacity_wh */ 9:
                    message.usableCapacityWh = reader.double();
                    break;
                case /* int64 capacity_measured_at */ 10:
                    message.capacityMeasuredAt = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string serial_number = 3; */
        if (message.serialNumber !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.serialNumber);
        /* string external_id = 4; */
        if (message.externalId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.externalId);
        /* devices.v1.DeploymentStatus deployment_status = 6; */
        if (message.deploymentStatus !== 0)
            writer.tag(6, WireType.Varint).int32(message.deploymentStatus);
        /* string site_id = 7; */
        if (message.siteId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.siteId);
        /* string model_id = 8; */
        if (message.modelId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.modelId);
        /* optional double usable_capacity_wh = 9; */
        if (message.usableCapacityWh !== undefined)
            writer.tag(9, WireType.Bit64).double(message.usableCapacityWh);
        /* int64 capacity_measured_at = 10; */
        if (message.capacityMeasuredAt !== 0n)
            writer.tag(10, WireType.Varint).int64(message.capacityMeasuredAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateStationaryBatteryRequest
 */
export const CreateStationaryBatteryRequest = new CreateStationaryBatteryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateStationaryBatteryResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateStationaryBatteryResponse", [
            { no: 1, name: "battery", kind: "message", T: () => StationaryBattery }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.StationaryBattery battery */ 1:
                    message.battery = StationaryBattery.internalBinaryRead(reader, reader.uint32(), options, message.battery);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.StationaryBattery battery = 1; */
        if (message.battery)
            StationaryBattery.internalBinaryWrite(message.battery, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateStationaryBatteryResponse
 */
export const CreateStationaryBatteryResponse = new CreateStationaryBatteryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStationaryBatteryRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.GetStationaryBatteryRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.HydrationOptions hydration */ 2:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.HydrationOptions hydration = 2; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetStationaryBatteryRequest
 */
export const GetStationaryBatteryRequest = new GetStationaryBatteryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStationaryBatteryResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.GetStationaryBatteryResponse", [
            { no: 1, name: "battery", kind: "message", T: () => StationaryBattery }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.StationaryBattery battery */ 1:
                    message.battery = StationaryBattery.internalBinaryRead(reader, reader.uint32(), options, message.battery);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.StationaryBattery battery = 1; */
        if (message.battery)
            StationaryBattery.internalBinaryWrite(message.battery, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetStationaryBatteryResponse
 */
export const GetStationaryBatteryResponse = new GetStationaryBatteryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListStationaryBatteriesRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.ListStationaryBatteriesRequest", [
            { no: 1, name: "device_filter", kind: "message", T: () => DeviceFilter },
            { no: 2, name: "site_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "deployment_status", kind: "enum", T: () => ["devices.v1.DeploymentStatus", DeploymentStatus, "DEPLOYMENT_STATUS_"] },
            { no: 4, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 5, name: "sort", kind: "message", T: () => SortOptions },
            { no: 6, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.siteId = "";
        message.deploymentStatus = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.DeviceFilter device_filter */ 1:
                    message.deviceFilter = DeviceFilter.internalBinaryRead(reader, reader.uint32(), options, message.deviceFilter);
                    break;
                case /* string site_id */ 2:
                    message.siteId = reader.string();
                    break;
                case /* devices.v1.DeploymentStatus deployment_status */ 3:
                    message.deploymentStatus = reader.int32();
                    break;
                case /* common.v1.PaginationRequest pagination */ 4:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* devices.v1.SortOptions sort */ 5:
                    message.sort = SortOptions.internalBinaryRead(reader, reader.uint32(), options, message.sort);
                    break;
                case /* devices.v1.HydrationOptions hydration */ 6:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.DeviceFilter device_filter = 1; */
        if (message.deviceFilter)
            DeviceFilter.internalBinaryWrite(message.deviceFilter, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string site_id = 2; */
        if (message.siteId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.siteId);
        /* devices.v1.DeploymentStatus deployment_status = 3; */
        if (message.deploymentStatus !== 0)
            writer.tag(3, WireType.Varint).int32(message.deploymentStatus);
        /* common.v1.PaginationRequest pagination = 4; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.SortOptions sort = 5; */
        if (message.sort)
            SortOptions.internalBinaryWrite(message.sort, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.HydrationOptions hydration = 6; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListStationaryBatteriesRequest
 */
export const ListStationaryBatteriesRequest = new ListStationaryBatteriesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListStationaryBatteriesResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.ListStationaryBatteriesResponse", [
            { no: 1, name: "batteries", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => StationaryBattery },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.batteries = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated devices.v1.StationaryBattery batteries */ 1:
                    message.batteries.push(StationaryBattery.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated devices.v1.StationaryBattery batteries = 1; */
        for (let i = 0; i < message.batteries.length; i++)
            StationaryBattery.internalBinaryWrite(message.batteries[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListStationaryBatteriesResponse
 */
export const ListStationaryBatteriesResponse = new ListStationaryBatteriesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateStationaryBatteryRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateStationaryBatteryRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "battery", kind: "message", T: () => StationaryBattery },
            { no: 3, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.StationaryBattery battery */ 2:
                    message.battery = StationaryBattery.internalBinaryRead(reader, reader.uint32(), options, message.battery);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 3:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.StationaryBattery battery = 2; */
        if (message.battery)
            StationaryBattery.internalBinaryWrite(message.battery, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 3; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateStationaryBatteryRequest
 */
export const UpdateStationaryBatteryRequest = new UpdateStationaryBatteryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateStationaryBatteryResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateStationaryBatteryResponse", [
            { no: 1, name: "battery", kind: "message", T: () => StationaryBattery }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.StationaryBattery battery */ 1:
                    message.battery = StationaryBattery.internalBinaryRead(reader, reader.uint32(), options, message.battery);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.StationaryBattery battery = 1; */
        if (message.battery)
            StationaryBattery.internalBinaryWrite(message.battery, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateStationaryBatteryResponse
 */
export const UpdateStationaryBatteryResponse = new UpdateStationaryBatteryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteStationaryBatteryRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteStationaryBatteryRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "permanent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.permanent = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bool permanent */ 2:
                    message.permanent = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bool permanent = 2; */
        if (message.permanent !== false)
            writer.tag(2, WireType.Varint).bool(message.permanent);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteStationaryBatteryRequest
 */
export const DeleteStationaryBatteryRequest = new DeleteStationaryBatteryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteStationaryBatteryResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteStationaryBatteryResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteStationaryBatteryResponse
 */
export const DeleteStationaryBatteryResponse = new DeleteStationaryBatteryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateStationModelRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateStationModelRequest", [
            { no: 1, name: "model", kind: "message", T: () => StationModel }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.StationModel model */ 1:
                    message.model = StationModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.StationModel model = 1; */
        if (message.model)
            StationModel.internalBinaryWrite(message.model, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateStationModelRequest
 */
export const CreateStationModelRequest = new CreateStationModelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateStationModelResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateStationModelResponse", [
            { no: 1, name: "model", kind: "message", T: () => StationModel }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.StationModel model */ 1:
                    message.model = StationModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.StationModel model = 1; */
        if (message.model)
            StationModel.internalBinaryWrite(message.model, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateStationModelResponse
 */
export const CreateStationModelResponse = new CreateStationModelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStationModelRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.GetStationModelRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.HydrationOptions hydration */ 2:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.HydrationOptions hydration = 2; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetStationModelRequest
 */
export const GetStationModelRequest = new GetStationModelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStationModelResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.GetStationModelResponse", [
            { no: 1, name: "model", kind: "message", T: () => StationModel }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.StationModel model */ 1:
                    message.model = StationModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.StationModel model = 1; */
        if (message.model)
            StationModel.internalBinaryWrite(message.model, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetStationModelResponse
 */
export const GetStationModelResponse = new GetStationModelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListStationModelsRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.ListStationModelsRequest", [
            { no: 1, name: "manufacturer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "communication_protocol", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 4, name: "sort", kind: "message", T: () => SortOptions },
            { no: 5, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.manufacturer = "";
        message.communicationProtocol = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string manufacturer */ 1:
                    message.manufacturer = reader.string();
                    break;
                case /* string communication_protocol */ 2:
                    message.communicationProtocol = reader.string();
                    break;
                case /* common.v1.PaginationRequest pagination */ 3:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* devices.v1.SortOptions sort */ 4:
                    message.sort = SortOptions.internalBinaryRead(reader, reader.uint32(), options, message.sort);
                    break;
                case /* devices.v1.HydrationOptions hydration */ 5:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string manufacturer = 1; */
        if (message.manufacturer !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.manufacturer);
        /* string communication_protocol = 2; */
        if (message.communicationProtocol !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.communicationProtocol);
        /* common.v1.PaginationRequest pagination = 3; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.SortOptions sort = 4; */
        if (message.sort)
            SortOptions.internalBinaryWrite(message.sort, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.HydrationOptions hydration = 5; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListStationModelsRequest
 */
export const ListStationModelsRequest = new ListStationModelsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListStationModelsResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.ListStationModelsResponse", [
            { no: 1, name: "models", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => StationModel },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.models = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated devices.v1.StationModel models */ 1:
                    message.models.push(StationModel.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated devices.v1.StationModel models = 1; */
        for (let i = 0; i < message.models.length; i++)
            StationModel.internalBinaryWrite(message.models[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListStationModelsResponse
 */
export const ListStationModelsResponse = new ListStationModelsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateStationModelRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateStationModelRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "model", kind: "message", T: () => StationModel },
            { no: 3, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.StationModel model */ 2:
                    message.model = StationModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 3:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.StationModel model = 2; */
        if (message.model)
            StationModel.internalBinaryWrite(message.model, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 3; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateStationModelRequest
 */
export const UpdateStationModelRequest = new UpdateStationModelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateStationModelResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateStationModelResponse", [
            { no: 1, name: "model", kind: "message", T: () => StationModel }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.StationModel model */ 1:
                    message.model = StationModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.StationModel model = 1; */
        if (message.model)
            StationModel.internalBinaryWrite(message.model, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateStationModelResponse
 */
export const UpdateStationModelResponse = new UpdateStationModelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteStationModelRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteStationModelRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteStationModelRequest
 */
export const DeleteStationModelRequest = new DeleteStationModelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteStationModelResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteStationModelResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteStationModelResponse
 */
export const DeleteStationModelResponse = new DeleteStationModelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateEvseModelRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateEvseModelRequest", [
            { no: 1, name: "model", kind: "message", T: () => EvseModel }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.EvseModel model */ 1:
                    message.model = EvseModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.EvseModel model = 1; */
        if (message.model)
            EvseModel.internalBinaryWrite(message.model, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateEvseModelRequest
 */
export const CreateEvseModelRequest = new CreateEvseModelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateEvseModelResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateEvseModelResponse", [
            { no: 1, name: "model", kind: "message", T: () => EvseModel }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.EvseModel model */ 1:
                    message.model = EvseModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.EvseModel model = 1; */
        if (message.model)
            EvseModel.internalBinaryWrite(message.model, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateEvseModelResponse
 */
export const CreateEvseModelResponse = new CreateEvseModelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetEvseModelRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.GetEvseModelRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.HydrationOptions hydration */ 2:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.HydrationOptions hydration = 2; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetEvseModelRequest
 */
export const GetEvseModelRequest = new GetEvseModelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetEvseModelResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.GetEvseModelResponse", [
            { no: 1, name: "model", kind: "message", T: () => EvseModel }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.EvseModel model */ 1:
                    message.model = EvseModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.EvseModel model = 1; */
        if (message.model)
            EvseModel.internalBinaryWrite(message.model, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetEvseModelResponse
 */
export const GetEvseModelResponse = new GetEvseModelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListEvseModelsRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.ListEvseModelsRequest", [
            { no: 1, name: "manufacturer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 3, name: "sort", kind: "message", T: () => SortOptions },
            { no: 4, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.manufacturer = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string manufacturer */ 1:
                    message.manufacturer = reader.string();
                    break;
                case /* common.v1.PaginationRequest pagination */ 2:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* devices.v1.SortOptions sort */ 3:
                    message.sort = SortOptions.internalBinaryRead(reader, reader.uint32(), options, message.sort);
                    break;
                case /* devices.v1.HydrationOptions hydration */ 4:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string manufacturer = 1; */
        if (message.manufacturer !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.manufacturer);
        /* common.v1.PaginationRequest pagination = 2; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.SortOptions sort = 3; */
        if (message.sort)
            SortOptions.internalBinaryWrite(message.sort, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.HydrationOptions hydration = 4; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListEvseModelsRequest
 */
export const ListEvseModelsRequest = new ListEvseModelsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListEvseModelsResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.ListEvseModelsResponse", [
            { no: 1, name: "models", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EvseModel },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.models = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated devices.v1.EvseModel models */ 1:
                    message.models.push(EvseModel.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated devices.v1.EvseModel models = 1; */
        for (let i = 0; i < message.models.length; i++)
            EvseModel.internalBinaryWrite(message.models[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListEvseModelsResponse
 */
export const ListEvseModelsResponse = new ListEvseModelsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateEvseModelRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateEvseModelRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "model", kind: "message", T: () => EvseModel },
            { no: 3, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.EvseModel model */ 2:
                    message.model = EvseModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 3:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.EvseModel model = 2; */
        if (message.model)
            EvseModel.internalBinaryWrite(message.model, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 3; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateEvseModelRequest
 */
export const UpdateEvseModelRequest = new UpdateEvseModelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateEvseModelResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateEvseModelResponse", [
            { no: 1, name: "model", kind: "message", T: () => EvseModel }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.EvseModel model */ 1:
                    message.model = EvseModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.EvseModel model = 1; */
        if (message.model)
            EvseModel.internalBinaryWrite(message.model, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateEvseModelResponse
 */
export const UpdateEvseModelResponse = new UpdateEvseModelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteEvseModelRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteEvseModelRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteEvseModelRequest
 */
export const DeleteEvseModelRequest = new DeleteEvseModelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteEvseModelResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteEvseModelResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteEvseModelResponse
 */
export const DeleteEvseModelResponse = new DeleteEvseModelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateConnectorModelRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateConnectorModelRequest", [
            { no: 1, name: "model", kind: "message", T: () => ConnectorModel }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.ConnectorModel model */ 1:
                    message.model = ConnectorModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.ConnectorModel model = 1; */
        if (message.model)
            ConnectorModel.internalBinaryWrite(message.model, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateConnectorModelRequest
 */
export const CreateConnectorModelRequest = new CreateConnectorModelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateConnectorModelResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateConnectorModelResponse", [
            { no: 1, name: "model", kind: "message", T: () => ConnectorModel }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.ConnectorModel model */ 1:
                    message.model = ConnectorModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.ConnectorModel model = 1; */
        if (message.model)
            ConnectorModel.internalBinaryWrite(message.model, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateConnectorModelResponse
 */
export const CreateConnectorModelResponse = new CreateConnectorModelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorModelRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.GetConnectorModelRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.HydrationOptions hydration */ 2:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.HydrationOptions hydration = 2; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetConnectorModelRequest
 */
export const GetConnectorModelRequest = new GetConnectorModelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConnectorModelResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.GetConnectorModelResponse", [
            { no: 1, name: "model", kind: "message", T: () => ConnectorModel }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.ConnectorModel model */ 1:
                    message.model = ConnectorModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.ConnectorModel model = 1; */
        if (message.model)
            ConnectorModel.internalBinaryWrite(message.model, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetConnectorModelResponse
 */
export const GetConnectorModelResponse = new GetConnectorModelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListConnectorModelsRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.ListConnectorModelsRequest", [
            { no: 1, name: "manufacturer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connector_type", kind: "enum", T: () => ["devices.v1.ConnectorType", ConnectorType, "CONNECTOR_TYPE_"] },
            { no: 3, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 4, name: "sort", kind: "message", T: () => SortOptions },
            { no: 5, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.manufacturer = "";
        message.connectorType = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string manufacturer */ 1:
                    message.manufacturer = reader.string();
                    break;
                case /* devices.v1.ConnectorType connector_type */ 2:
                    message.connectorType = reader.int32();
                    break;
                case /* common.v1.PaginationRequest pagination */ 3:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* devices.v1.SortOptions sort */ 4:
                    message.sort = SortOptions.internalBinaryRead(reader, reader.uint32(), options, message.sort);
                    break;
                case /* devices.v1.HydrationOptions hydration */ 5:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string manufacturer = 1; */
        if (message.manufacturer !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.manufacturer);
        /* devices.v1.ConnectorType connector_type = 2; */
        if (message.connectorType !== 0)
            writer.tag(2, WireType.Varint).int32(message.connectorType);
        /* common.v1.PaginationRequest pagination = 3; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.SortOptions sort = 4; */
        if (message.sort)
            SortOptions.internalBinaryWrite(message.sort, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.HydrationOptions hydration = 5; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListConnectorModelsRequest
 */
export const ListConnectorModelsRequest = new ListConnectorModelsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListConnectorModelsResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.ListConnectorModelsResponse", [
            { no: 1, name: "models", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorModel },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.models = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated devices.v1.ConnectorModel models */ 1:
                    message.models.push(ConnectorModel.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated devices.v1.ConnectorModel models = 1; */
        for (let i = 0; i < message.models.length; i++)
            ConnectorModel.internalBinaryWrite(message.models[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListConnectorModelsResponse
 */
export const ListConnectorModelsResponse = new ListConnectorModelsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateConnectorModelRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateConnectorModelRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "model", kind: "message", T: () => ConnectorModel },
            { no: 3, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.ConnectorModel model */ 2:
                    message.model = ConnectorModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 3:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.ConnectorModel model = 2; */
        if (message.model)
            ConnectorModel.internalBinaryWrite(message.model, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 3; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateConnectorModelRequest
 */
export const UpdateConnectorModelRequest = new UpdateConnectorModelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateConnectorModelResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateConnectorModelResponse", [
            { no: 1, name: "model", kind: "message", T: () => ConnectorModel }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.ConnectorModel model */ 1:
                    message.model = ConnectorModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.ConnectorModel model = 1; */
        if (message.model)
            ConnectorModel.internalBinaryWrite(message.model, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateConnectorModelResponse
 */
export const UpdateConnectorModelResponse = new UpdateConnectorModelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteConnectorModelRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteConnectorModelRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteConnectorModelRequest
 */
export const DeleteConnectorModelRequest = new DeleteConnectorModelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteConnectorModelResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteConnectorModelResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteConnectorModelResponse
 */
export const DeleteConnectorModelResponse = new DeleteConnectorModelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateStationBatteryModelRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateStationBatteryModelRequest", [
            { no: 1, name: "model", kind: "message", T: () => StationBatteryModel }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.StationBatteryModel model */ 1:
                    message.model = StationBatteryModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.StationBatteryModel model = 1; */
        if (message.model)
            StationBatteryModel.internalBinaryWrite(message.model, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateStationBatteryModelRequest
 */
export const CreateStationBatteryModelRequest = new CreateStationBatteryModelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateStationBatteryModelResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateStationBatteryModelResponse", [
            { no: 1, name: "model", kind: "message", T: () => StationBatteryModel }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.StationBatteryModel model */ 1:
                    message.model = StationBatteryModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.StationBatteryModel model = 1; */
        if (message.model)
            StationBatteryModel.internalBinaryWrite(message.model, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateStationBatteryModelResponse
 */
export const CreateStationBatteryModelResponse = new CreateStationBatteryModelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStationBatteryModelRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.GetStationBatteryModelRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.HydrationOptions hydration */ 2:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.HydrationOptions hydration = 2; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetStationBatteryModelRequest
 */
export const GetStationBatteryModelRequest = new GetStationBatteryModelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStationBatteryModelResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.GetStationBatteryModelResponse", [
            { no: 1, name: "model", kind: "message", T: () => StationBatteryModel }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.StationBatteryModel model */ 1:
                    message.model = StationBatteryModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.StationBatteryModel model = 1; */
        if (message.model)
            StationBatteryModel.internalBinaryWrite(message.model, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetStationBatteryModelResponse
 */
export const GetStationBatteryModelResponse = new GetStationBatteryModelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListStationBatteryModelsRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.ListStationBatteryModelsRequest", [
            { no: 1, name: "manufacturer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "communication_protocol", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 4, name: "sort", kind: "message", T: () => SortOptions },
            { no: 5, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.manufacturer = "";
        message.communicationProtocol = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string manufacturer */ 1:
                    message.manufacturer = reader.string();
                    break;
                case /* string communication_protocol */ 2:
                    message.communicationProtocol = reader.string();
                    break;
                case /* common.v1.PaginationRequest pagination */ 3:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* devices.v1.SortOptions sort */ 4:
                    message.sort = SortOptions.internalBinaryRead(reader, reader.uint32(), options, message.sort);
                    break;
                case /* devices.v1.HydrationOptions hydration */ 5:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string manufacturer = 1; */
        if (message.manufacturer !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.manufacturer);
        /* string communication_protocol = 2; */
        if (message.communicationProtocol !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.communicationProtocol);
        /* common.v1.PaginationRequest pagination = 3; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.SortOptions sort = 4; */
        if (message.sort)
            SortOptions.internalBinaryWrite(message.sort, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.HydrationOptions hydration = 5; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListStationBatteryModelsRequest
 */
export const ListStationBatteryModelsRequest = new ListStationBatteryModelsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListStationBatteryModelsResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.ListStationBatteryModelsResponse", [
            { no: 1, name: "models", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => StationBatteryModel },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.models = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated devices.v1.StationBatteryModel models */ 1:
                    message.models.push(StationBatteryModel.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated devices.v1.StationBatteryModel models = 1; */
        for (let i = 0; i < message.models.length; i++)
            StationBatteryModel.internalBinaryWrite(message.models[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListStationBatteryModelsResponse
 */
export const ListStationBatteryModelsResponse = new ListStationBatteryModelsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateStationBatteryModelRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateStationBatteryModelRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "model", kind: "message", T: () => StationBatteryModel },
            { no: 3, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.StationBatteryModel model */ 2:
                    message.model = StationBatteryModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 3:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.StationBatteryModel model = 2; */
        if (message.model)
            StationBatteryModel.internalBinaryWrite(message.model, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 3; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateStationBatteryModelRequest
 */
export const UpdateStationBatteryModelRequest = new UpdateStationBatteryModelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateStationBatteryModelResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateStationBatteryModelResponse", [
            { no: 1, name: "model", kind: "message", T: () => StationBatteryModel }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.StationBatteryModel model */ 1:
                    message.model = StationBatteryModel.internalBinaryRead(reader, reader.uint32(), options, message.model);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.StationBatteryModel model = 1; */
        if (message.model)
            StationBatteryModel.internalBinaryWrite(message.model, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateStationBatteryModelResponse
 */
export const UpdateStationBatteryModelResponse = new UpdateStationBatteryModelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteStationBatteryModelRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteStationBatteryModelRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteStationBatteryModelRequest
 */
export const DeleteStationBatteryModelRequest = new DeleteStationBatteryModelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteStationBatteryModelResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteStationBatteryModelResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteStationBatteryModelResponse
 */
export const DeleteStationBatteryModelResponse = new DeleteStationBatteryModelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCommunicationProtocolRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateCommunicationProtocolRequest", [
            { no: 1, name: "protocol", kind: "message", T: () => DeviceCommunicationProtocol }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.DeviceCommunicationProtocol protocol */ 1:
                    message.protocol = DeviceCommunicationProtocol.internalBinaryRead(reader, reader.uint32(), options, message.protocol);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.DeviceCommunicationProtocol protocol = 1; */
        if (message.protocol)
            DeviceCommunicationProtocol.internalBinaryWrite(message.protocol, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateCommunicationProtocolRequest
 */
export const CreateCommunicationProtocolRequest = new CreateCommunicationProtocolRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateCommunicationProtocolResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateCommunicationProtocolResponse", [
            { no: 1, name: "protocol", kind: "message", T: () => DeviceCommunicationProtocol }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.DeviceCommunicationProtocol protocol */ 1:
                    message.protocol = DeviceCommunicationProtocol.internalBinaryRead(reader, reader.uint32(), options, message.protocol);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.DeviceCommunicationProtocol protocol = 1; */
        if (message.protocol)
            DeviceCommunicationProtocol.internalBinaryWrite(message.protocol, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateCommunicationProtocolResponse
 */
export const CreateCommunicationProtocolResponse = new CreateCommunicationProtocolResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCommunicationProtocolsRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.ListCommunicationProtocolsRequest", [
            { no: 1, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 2, name: "sort", kind: "message", T: () => SortOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* common.v1.PaginationRequest pagination */ 1:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* devices.v1.SortOptions sort */ 2:
                    message.sort = SortOptions.internalBinaryRead(reader, reader.uint32(), options, message.sort);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* common.v1.PaginationRequest pagination = 1; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.SortOptions sort = 2; */
        if (message.sort)
            SortOptions.internalBinaryWrite(message.sort, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListCommunicationProtocolsRequest
 */
export const ListCommunicationProtocolsRequest = new ListCommunicationProtocolsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListCommunicationProtocolsResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.ListCommunicationProtocolsResponse", [
            { no: 1, name: "protocols", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DeviceCommunicationProtocol },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.protocols = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated devices.v1.DeviceCommunicationProtocol protocols */ 1:
                    message.protocols.push(DeviceCommunicationProtocol.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated devices.v1.DeviceCommunicationProtocol protocols = 1; */
        for (let i = 0; i < message.protocols.length; i++)
            DeviceCommunicationProtocol.internalBinaryWrite(message.protocols[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListCommunicationProtocolsResponse
 */
export const ListCommunicationProtocolsResponse = new ListCommunicationProtocolsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCommunicationProtocolRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateCommunicationProtocolRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "protocol", kind: "message", T: () => DeviceCommunicationProtocol },
            { no: 3, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.DeviceCommunicationProtocol protocol */ 2:
                    message.protocol = DeviceCommunicationProtocol.internalBinaryRead(reader, reader.uint32(), options, message.protocol);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 3:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.DeviceCommunicationProtocol protocol = 2; */
        if (message.protocol)
            DeviceCommunicationProtocol.internalBinaryWrite(message.protocol, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 3; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateCommunicationProtocolRequest
 */
export const UpdateCommunicationProtocolRequest = new UpdateCommunicationProtocolRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateCommunicationProtocolResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateCommunicationProtocolResponse", [
            { no: 1, name: "protocol", kind: "message", T: () => DeviceCommunicationProtocol }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.DeviceCommunicationProtocol protocol */ 1:
                    message.protocol = DeviceCommunicationProtocol.internalBinaryRead(reader, reader.uint32(), options, message.protocol);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.DeviceCommunicationProtocol protocol = 1; */
        if (message.protocol)
            DeviceCommunicationProtocol.internalBinaryWrite(message.protocol, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateCommunicationProtocolResponse
 */
export const UpdateCommunicationProtocolResponse = new UpdateCommunicationProtocolResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCommunicationProtocolRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteCommunicationProtocolRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteCommunicationProtocolRequest
 */
export const DeleteCommunicationProtocolRequest = new DeleteCommunicationProtocolRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteCommunicationProtocolResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteCommunicationProtocolResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteCommunicationProtocolResponse
 */
export const DeleteCommunicationProtocolResponse = new DeleteCommunicationProtocolResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDeviceErrorRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateDeviceErrorRequest", [
            { no: 1, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "error_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "details", kind: "message", T: () => Struct }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.deviceId = "";
        message.modelId = "";
        message.errorCode = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string device_id */ 1:
                    message.deviceId = reader.string();
                    break;
                case /* string model_id */ 2:
                    message.modelId = reader.string();
                    break;
                case /* string error_code */ 3:
                    message.errorCode = reader.string();
                    break;
                case /* google.protobuf.Struct details */ 4:
                    message.details = Struct.internalBinaryRead(reader, reader.uint32(), options, message.details);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string device_id = 1; */
        if (message.deviceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.deviceId);
        /* string model_id = 2; */
        if (message.modelId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.modelId);
        /* string error_code = 3; */
        if (message.errorCode !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorCode);
        /* google.protobuf.Struct details = 4; */
        if (message.details)
            Struct.internalBinaryWrite(message.details, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateDeviceErrorRequest
 */
export const CreateDeviceErrorRequest = new CreateDeviceErrorRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDeviceErrorResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateDeviceErrorResponse", [
            { no: 1, name: "error", kind: "message", T: () => DeviceError }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.DeviceError error */ 1:
                    message.error = DeviceError.internalBinaryRead(reader, reader.uint32(), options, message.error);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.DeviceError error = 1; */
        if (message.error)
            DeviceError.internalBinaryWrite(message.error, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateDeviceErrorResponse
 */
export const CreateDeviceErrorResponse = new CreateDeviceErrorResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeviceErrorRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.GetDeviceErrorRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "hydration", kind: "message", T: () => HydrationOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.HydrationOptions hydration */ 2:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.HydrationOptions hydration = 2; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetDeviceErrorRequest
 */
export const GetDeviceErrorRequest = new GetDeviceErrorRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeviceErrorResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.GetDeviceErrorResponse", [
            { no: 1, name: "error", kind: "message", T: () => DeviceError }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.DeviceError error */ 1:
                    message.error = DeviceError.internalBinaryRead(reader, reader.uint32(), options, message.error);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.DeviceError error = 1; */
        if (message.error)
            DeviceError.internalBinaryWrite(message.error, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetDeviceErrorResponse
 */
export const GetDeviceErrorResponse = new GetDeviceErrorResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDeviceErrorsRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.ListDeviceErrorsRequest", [
            { no: 1, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "criticality", kind: "enum", T: () => ["devices.v1.CriticalityLevel", CriticalityLevel, "CRITICALITY_LEVEL_"] },
            { no: 4, name: "unresolved_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 6, name: "sort", kind: "message", T: () => SortOptions },
            { no: 7, name: "hydration", kind: "message", T: () => HydrationOptions },
            { no: 8, name: "error_category", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.deviceId = "";
        message.modelId = "";
        message.criticality = 0;
        message.unresolvedOnly = false;
        message.errorCategory = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string device_id */ 1:
                    message.deviceId = reader.string();
                    break;
                case /* string model_id */ 2:
                    message.modelId = reader.string();
                    break;
                case /* devices.v1.CriticalityLevel criticality */ 3:
                    message.criticality = reader.int32();
                    break;
                case /* bool unresolved_only */ 4:
                    message.unresolvedOnly = reader.bool();
                    break;
                case /* common.v1.PaginationRequest pagination */ 5:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* devices.v1.SortOptions sort */ 6:
                    message.sort = SortOptions.internalBinaryRead(reader, reader.uint32(), options, message.sort);
                    break;
                case /* devices.v1.HydrationOptions hydration */ 7:
                    message.hydration = HydrationOptions.internalBinaryRead(reader, reader.uint32(), options, message.hydration);
                    break;
                case /* string error_category */ 8:
                    message.errorCategory = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string device_id = 1; */
        if (message.deviceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.deviceId);
        /* string model_id = 2; */
        if (message.modelId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.modelId);
        /* devices.v1.CriticalityLevel criticality = 3; */
        if (message.criticality !== 0)
            writer.tag(3, WireType.Varint).int32(message.criticality);
        /* bool unresolved_only = 4; */
        if (message.unresolvedOnly !== false)
            writer.tag(4, WireType.Varint).bool(message.unresolvedOnly);
        /* common.v1.PaginationRequest pagination = 5; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.SortOptions sort = 6; */
        if (message.sort)
            SortOptions.internalBinaryWrite(message.sort, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.HydrationOptions hydration = 7; */
        if (message.hydration)
            HydrationOptions.internalBinaryWrite(message.hydration, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string error_category = 8; */
        if (message.errorCategory !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.errorCategory);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListDeviceErrorsRequest
 */
export const ListDeviceErrorsRequest = new ListDeviceErrorsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDeviceErrorsResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.ListDeviceErrorsResponse", [
            { no: 1, name: "errors", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DeviceError },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.errors = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated devices.v1.DeviceError errors */ 1:
                    message.errors.push(DeviceError.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated devices.v1.DeviceError errors = 1; */
        for (let i = 0; i < message.errors.length; i++)
            DeviceError.internalBinaryWrite(message.errors[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListDeviceErrorsResponse
 */
export const ListDeviceErrorsResponse = new ListDeviceErrorsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResolveDeviceErrorRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.ResolveDeviceErrorRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resolution_details", kind: "message", T: () => Struct }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Struct resolution_details */ 2:
                    message.resolutionDetails = Struct.internalBinaryRead(reader, reader.uint32(), options, message.resolutionDetails);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Struct resolution_details = 2; */
        if (message.resolutionDetails)
            Struct.internalBinaryWrite(message.resolutionDetails, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ResolveDeviceErrorRequest
 */
export const ResolveDeviceErrorRequest = new ResolveDeviceErrorRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResolveDeviceErrorResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.ResolveDeviceErrorResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ResolveDeviceErrorResponse
 */
export const ResolveDeviceErrorResponse = new ResolveDeviceErrorResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDeviceErrorTypeRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateDeviceErrorTypeRequest", [
            { no: 1, name: "error_type", kind: "message", T: () => DeviceErrorType }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.DeviceErrorType error_type */ 1:
                    message.errorType = DeviceErrorType.internalBinaryRead(reader, reader.uint32(), options, message.errorType);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.DeviceErrorType error_type = 1; */
        if (message.errorType)
            DeviceErrorType.internalBinaryWrite(message.errorType, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateDeviceErrorTypeRequest
 */
export const CreateDeviceErrorTypeRequest = new CreateDeviceErrorTypeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDeviceErrorTypeResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateDeviceErrorTypeResponse", [
            { no: 1, name: "error_type", kind: "message", T: () => DeviceErrorType }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.DeviceErrorType error_type */ 1:
                    message.errorType = DeviceErrorType.internalBinaryRead(reader, reader.uint32(), options, message.errorType);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.DeviceErrorType error_type = 1; */
        if (message.errorType)
            DeviceErrorType.internalBinaryWrite(message.errorType, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateDeviceErrorTypeResponse
 */
export const CreateDeviceErrorTypeResponse = new CreateDeviceErrorTypeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeviceErrorTypeRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.GetDeviceErrorTypeRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetDeviceErrorTypeRequest
 */
export const GetDeviceErrorTypeRequest = new GetDeviceErrorTypeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeviceErrorTypeResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.GetDeviceErrorTypeResponse", [
            { no: 1, name: "error_type", kind: "message", T: () => DeviceErrorType }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.DeviceErrorType error_type */ 1:
                    message.errorType = DeviceErrorType.internalBinaryRead(reader, reader.uint32(), options, message.errorType);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.DeviceErrorType error_type = 1; */
        if (message.errorType)
            DeviceErrorType.internalBinaryWrite(message.errorType, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetDeviceErrorTypeResponse
 */
export const GetDeviceErrorTypeResponse = new GetDeviceErrorTypeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDeviceErrorTypesRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.ListDeviceErrorTypesRequest", [
            { no: 1, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "criticality", kind: "enum", T: () => ["devices.v1.CriticalityLevel", CriticalityLevel, "CRITICALITY_LEVEL_"] },
            { no: 3, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 4, name: "sort", kind: "message", T: () => SortOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.modelId = "";
        message.criticality = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string model_id */ 1:
                    message.modelId = reader.string();
                    break;
                case /* devices.v1.CriticalityLevel criticality */ 2:
                    message.criticality = reader.int32();
                    break;
                case /* common.v1.PaginationRequest pagination */ 3:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* devices.v1.SortOptions sort */ 4:
                    message.sort = SortOptions.internalBinaryRead(reader, reader.uint32(), options, message.sort);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string model_id = 1; */
        if (message.modelId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.modelId);
        /* devices.v1.CriticalityLevel criticality = 2; */
        if (message.criticality !== 0)
            writer.tag(2, WireType.Varint).int32(message.criticality);
        /* common.v1.PaginationRequest pagination = 3; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.SortOptions sort = 4; */
        if (message.sort)
            SortOptions.internalBinaryWrite(message.sort, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListDeviceErrorTypesRequest
 */
export const ListDeviceErrorTypesRequest = new ListDeviceErrorTypesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDeviceErrorTypesResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.ListDeviceErrorTypesResponse", [
            { no: 1, name: "error_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DeviceErrorType },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.errorTypes = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated devices.v1.DeviceErrorType error_types */ 1:
                    message.errorTypes.push(DeviceErrorType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated devices.v1.DeviceErrorType error_types = 1; */
        for (let i = 0; i < message.errorTypes.length; i++)
            DeviceErrorType.internalBinaryWrite(message.errorTypes[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListDeviceErrorTypesResponse
 */
export const ListDeviceErrorTypesResponse = new ListDeviceErrorTypesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDeviceErrorTypeRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateDeviceErrorTypeRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "error_type", kind: "message", T: () => DeviceErrorType },
            { no: 3, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* devices.v1.DeviceErrorType error_type */ 2:
                    message.errorType = DeviceErrorType.internalBinaryRead(reader, reader.uint32(), options, message.errorType);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 3:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* devices.v1.DeviceErrorType error_type = 2; */
        if (message.errorType)
            DeviceErrorType.internalBinaryWrite(message.errorType, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 3; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateDeviceErrorTypeRequest
 */
export const UpdateDeviceErrorTypeRequest = new UpdateDeviceErrorTypeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDeviceErrorTypeResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateDeviceErrorTypeResponse", [
            { no: 1, name: "error_type", kind: "message", T: () => DeviceErrorType }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.DeviceErrorType error_type */ 1:
                    message.errorType = DeviceErrorType.internalBinaryRead(reader, reader.uint32(), options, message.errorType);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.DeviceErrorType error_type = 1; */
        if (message.errorType)
            DeviceErrorType.internalBinaryWrite(message.errorType, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateDeviceErrorTypeResponse
 */
export const UpdateDeviceErrorTypeResponse = new UpdateDeviceErrorTypeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDeviceErrorTypeRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteDeviceErrorTypeRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteDeviceErrorTypeRequest
 */
export const DeleteDeviceErrorTypeRequest = new DeleteDeviceErrorTypeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDeviceErrorTypeResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteDeviceErrorTypeResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteDeviceErrorTypeResponse
 */
export const DeleteDeviceErrorTypeResponse = new DeleteDeviceErrorTypeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListControlSignalTypesRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.ListControlSignalTypesRequest", [
            { no: 1, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationRequest },
            { no: 3, name: "sort", kind: "message", T: () => SortOptions }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.modelId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string model_id */ 1:
                    message.modelId = reader.string();
                    break;
                case /* common.v1.PaginationRequest pagination */ 2:
                    message.pagination = PaginationRequest.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                case /* devices.v1.SortOptions sort */ 3:
                    message.sort = SortOptions.internalBinaryRead(reader, reader.uint32(), options, message.sort);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string model_id = 1; */
        if (message.modelId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.modelId);
        /* common.v1.PaginationRequest pagination = 2; */
        if (message.pagination)
            PaginationRequest.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* devices.v1.SortOptions sort = 3; */
        if (message.sort)
            SortOptions.internalBinaryWrite(message.sort, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListControlSignalTypesRequest
 */
export const ListControlSignalTypesRequest = new ListControlSignalTypesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListControlSignalTypesResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.ListControlSignalTypesResponse", [
            { no: 1, name: "signal_types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ControlSignalType },
            { no: 2, name: "pagination", kind: "message", T: () => PaginationResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.signalTypes = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated devices.v1.ControlSignalType signal_types */ 1:
                    message.signalTypes.push(ControlSignalType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* common.v1.PaginationResponse pagination */ 2:
                    message.pagination = PaginationResponse.internalBinaryRead(reader, reader.uint32(), options, message.pagination);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated devices.v1.ControlSignalType signal_types = 1; */
        for (let i = 0; i < message.signalTypes.length; i++)
            ControlSignalType.internalBinaryWrite(message.signalTypes[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* common.v1.PaginationResponse pagination = 2; */
        if (message.pagination)
            PaginationResponse.internalBinaryWrite(message.pagination, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListControlSignalTypesResponse
 */
export const ListControlSignalTypesResponse = new ListControlSignalTypesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateControlSignalTypeRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateControlSignalTypeRequest", [
            { no: 1, name: "signal_type", kind: "message", T: () => ControlSignalType }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.ControlSignalType signal_type */ 1:
                    message.signalType = ControlSignalType.internalBinaryRead(reader, reader.uint32(), options, message.signalType);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.ControlSignalType signal_type = 1; */
        if (message.signalType)
            ControlSignalType.internalBinaryWrite(message.signalType, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateControlSignalTypeRequest
 */
export const CreateControlSignalTypeRequest = new CreateControlSignalTypeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateControlSignalTypeResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.CreateControlSignalTypeResponse", [
            { no: 1, name: "signal_type", kind: "message", T: () => ControlSignalType }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.ControlSignalType signal_type */ 1:
                    message.signalType = ControlSignalType.internalBinaryRead(reader, reader.uint32(), options, message.signalType);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.ControlSignalType signal_type = 1; */
        if (message.signalType)
            ControlSignalType.internalBinaryWrite(message.signalType, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.CreateControlSignalTypeResponse
 */
export const CreateControlSignalTypeResponse = new CreateControlSignalTypeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateControlSignalTypeRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateControlSignalTypeRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "signal_type", kind: "message", T: () => ControlSignalType },
            { no: 4, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        message.modelId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string model_id */ 2:
                    message.modelId = reader.string();
                    break;
                case /* devices.v1.ControlSignalType signal_type */ 3:
                    message.signalType = ControlSignalType.internalBinaryRead(reader, reader.uint32(), options, message.signalType);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 4:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string model_id = 2; */
        if (message.modelId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.modelId);
        /* devices.v1.ControlSignalType signal_type = 3; */
        if (message.signalType)
            ControlSignalType.internalBinaryWrite(message.signalType, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 4; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateControlSignalTypeRequest
 */
export const UpdateControlSignalTypeRequest = new UpdateControlSignalTypeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateControlSignalTypeResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.UpdateControlSignalTypeResponse", [
            { no: 1, name: "signal_type", kind: "message", T: () => ControlSignalType }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.ControlSignalType signal_type */ 1:
                    message.signalType = ControlSignalType.internalBinaryRead(reader, reader.uint32(), options, message.signalType);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.ControlSignalType signal_type = 1; */
        if (message.signalType)
            ControlSignalType.internalBinaryWrite(message.signalType, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.UpdateControlSignalTypeResponse
 */
export const UpdateControlSignalTypeResponse = new UpdateControlSignalTypeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteControlSignalTypeRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteControlSignalTypeRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        message.modelId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string model_id */ 2:
                    message.modelId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string model_id = 2; */
        if (message.modelId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.modelId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteControlSignalTypeRequest
 */
export const DeleteControlSignalTypeRequest = new DeleteControlSignalTypeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteControlSignalTypeResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteControlSignalTypeResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteControlSignalTypeResponse
 */
export const DeleteControlSignalTypeResponse = new DeleteControlSignalTypeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeviceEnrichmentDataRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.GetDeviceEnrichmentDataRequest", [
            { no: 1, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.deviceId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string device_id */ 1:
                    message.deviceId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string device_id = 1; */
        if (message.deviceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.deviceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetDeviceEnrichmentDataRequest
 */
export const GetDeviceEnrichmentDataRequest = new GetDeviceEnrichmentDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeviceEnrichmentDataResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.GetDeviceEnrichmentDataResponse", [
            { no: 1, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "device_type", kind: "enum", T: () => ["devices.v1.DeviceType", DeviceType, "DEVICE_TYPE_"] },
            { no: 3, name: "site_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "dispatch_group_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "updated_at_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 10, name: "circuit_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "delivery_point_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "communication_protocol_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "charge_power_limit", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 14, name: "discharge_power_limit", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 15, name: "charge_energy_capacity", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 16, name: "discharge_energy_capacity", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 17, name: "model_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "min_soc_percentage", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 19, name: "max_soc_percentage", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 20, name: "external_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "customer_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.deviceId = "";
        message.deviceType = 0;
        message.updatedAtMs = 0n;
        message.customerIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string device_id */ 1:
                    message.deviceId = reader.string();
                    break;
                case /* devices.v1.DeviceType device_type */ 2:
                    message.deviceType = reader.int32();
                    break;
                case /* optional string site_id */ 3:
                    message.siteId = reader.string();
                    break;
                case /* optional string dispatch_group_id */ 4:
                    message.dispatchGroupId = reader.string();
                    break;
                case /* int64 updated_at_ms */ 9:
                    message.updatedAtMs = reader.int64().toBigInt();
                    break;
                case /* optional string circuit_id */ 10:
                    message.circuitId = reader.string();
                    break;
                case /* optional string delivery_point_id */ 11:
                    message.deliveryPointId = reader.string();
                    break;
                case /* optional string communication_protocol_name */ 12:
                    message.communicationProtocolName = reader.string();
                    break;
                case /* optional double charge_power_limit */ 13:
                    message.chargePowerLimit = reader.double();
                    break;
                case /* optional double discharge_power_limit */ 14:
                    message.dischargePowerLimit = reader.double();
                    break;
                case /* optional double charge_energy_capacity */ 15:
                    message.chargeEnergyCapacity = reader.double();
                    break;
                case /* optional double discharge_energy_capacity */ 16:
                    message.dischargeEnergyCapacity = reader.double();
                    break;
                case /* optional string model_name */ 17:
                    message.modelName = reader.string();
                    break;
                case /* optional int32 min_soc_percentage */ 18:
                    message.minSocPercentage = reader.int32();
                    break;
                case /* optional int32 max_soc_percentage */ 19:
                    message.maxSocPercentage = reader.int32();
                    break;
                case /* optional string external_id */ 20:
                    message.externalId = reader.string();
                    break;
                case /* repeated string customer_ids */ 21:
                    message.customerIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string device_id = 1; */
        if (message.deviceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.deviceId);
        /* devices.v1.DeviceType device_type = 2; */
        if (message.deviceType !== 0)
            writer.tag(2, WireType.Varint).int32(message.deviceType);
        /* optional string site_id = 3; */
        if (message.siteId !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.siteId);
        /* optional string dispatch_group_id = 4; */
        if (message.dispatchGroupId !== undefined)
            writer.tag(4, WireType.LengthDelimited).string(message.dispatchGroupId);
        /* int64 updated_at_ms = 9; */
        if (message.updatedAtMs !== 0n)
            writer.tag(9, WireType.Varint).int64(message.updatedAtMs);
        /* optional string circuit_id = 10; */
        if (message.circuitId !== undefined)
            writer.tag(10, WireType.LengthDelimited).string(message.circuitId);
        /* optional string delivery_point_id = 11; */
        if (message.deliveryPointId !== undefined)
            writer.tag(11, WireType.LengthDelimited).string(message.deliveryPointId);
        /* optional string communication_protocol_name = 12; */
        if (message.communicationProtocolName !== undefined)
            writer.tag(12, WireType.LengthDelimited).string(message.communicationProtocolName);
        /* optional double charge_power_limit = 13; */
        if (message.chargePowerLimit !== undefined)
            writer.tag(13, WireType.Bit64).double(message.chargePowerLimit);
        /* optional double discharge_power_limit = 14; */
        if (message.dischargePowerLimit !== undefined)
            writer.tag(14, WireType.Bit64).double(message.dischargePowerLimit);
        /* optional double charge_energy_capacity = 15; */
        if (message.chargeEnergyCapacity !== undefined)
            writer.tag(15, WireType.Bit64).double(message.chargeEnergyCapacity);
        /* optional double discharge_energy_capacity = 16; */
        if (message.dischargeEnergyCapacity !== undefined)
            writer.tag(16, WireType.Bit64).double(message.dischargeEnergyCapacity);
        /* optional string model_name = 17; */
        if (message.modelName !== undefined)
            writer.tag(17, WireType.LengthDelimited).string(message.modelName);
        /* optional int32 min_soc_percentage = 18; */
        if (message.minSocPercentage !== undefined)
            writer.tag(18, WireType.Varint).int32(message.minSocPercentage);
        /* optional int32 max_soc_percentage = 19; */
        if (message.maxSocPercentage !== undefined)
            writer.tag(19, WireType.Varint).int32(message.maxSocPercentage);
        /* optional string external_id = 20; */
        if (message.externalId !== undefined)
            writer.tag(20, WireType.LengthDelimited).string(message.externalId);
        /* repeated string customer_ids = 21; */
        for (let i = 0; i < message.customerIds.length; i++)
            writer.tag(21, WireType.LengthDelimited).string(message.customerIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetDeviceEnrichmentDataResponse
 */
export const GetDeviceEnrichmentDataResponse = new GetDeviceEnrichmentDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatchGetDeviceEnrichmentDataRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.BatchGetDeviceEnrichmentDataRequest", [
            { no: 1, name: "device_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.deviceIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string device_ids */ 1:
                    message.deviceIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated string device_ids = 1; */
        for (let i = 0; i < message.deviceIds.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.deviceIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.BatchGetDeviceEnrichmentDataRequest
 */
export const BatchGetDeviceEnrichmentDataRequest = new BatchGetDeviceEnrichmentDataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BatchGetDeviceEnrichmentDataResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.BatchGetDeviceEnrichmentDataResponse", [
            { no: 1, name: "enrichments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetDeviceEnrichmentDataResponse }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.enrichments = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated devices.v1.GetDeviceEnrichmentDataResponse enrichments */ 1:
                    message.enrichments.push(GetDeviceEnrichmentDataResponse.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated devices.v1.GetDeviceEnrichmentDataResponse enrichments = 1; */
        for (let i = 0; i < message.enrichments.length; i++)
            GetDeviceEnrichmentDataResponse.internalBinaryWrite(message.enrichments[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.BatchGetDeviceEnrichmentDataResponse
 */
export const BatchGetDeviceEnrichmentDataResponse = new BatchGetDeviceEnrichmentDataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetDeviceDefaultProfileRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.SetDeviceDefaultProfileRequest", [
            { no: 1, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "schedule_periods", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DeviceDefaultProfilePeriod },
            { no: 3, name: "profile_kind", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "recurrency_kind", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "start_schedule", kind: "message", T: () => Timestamp },
            { no: 6, name: "connector_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.deviceId = "";
        message.schedulePeriods = [];
        message.profileKind = "";
        message.recurrencyKind = "";
        message.connectorId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string device_id */ 1:
                    message.deviceId = reader.string();
                    break;
                case /* repeated devices.v1.DeviceDefaultProfilePeriod schedule_periods */ 2:
                    message.schedulePeriods.push(DeviceDefaultProfilePeriod.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string profile_kind */ 3:
                    message.profileKind = reader.string();
                    break;
                case /* string recurrency_kind */ 4:
                    message.recurrencyKind = reader.string();
                    break;
                case /* google.protobuf.Timestamp start_schedule */ 5:
                    message.startSchedule = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startSchedule);
                    break;
                case /* int32 connector_id */ 6:
                    message.connectorId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string device_id = 1; */
        if (message.deviceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.deviceId);
        /* repeated devices.v1.DeviceDefaultProfilePeriod schedule_periods = 2; */
        for (let i = 0; i < message.schedulePeriods.length; i++)
            DeviceDefaultProfilePeriod.internalBinaryWrite(message.schedulePeriods[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string profile_kind = 3; */
        if (message.profileKind !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.profileKind);
        /* string recurrency_kind = 4; */
        if (message.recurrencyKind !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.recurrencyKind);
        /* google.protobuf.Timestamp start_schedule = 5; */
        if (message.startSchedule)
            Timestamp.internalBinaryWrite(message.startSchedule, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* int32 connector_id = 6; */
        if (message.connectorId !== 0)
            writer.tag(6, WireType.Varint).int32(message.connectorId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.SetDeviceDefaultProfileRequest
 */
export const SetDeviceDefaultProfileRequest = new SetDeviceDefaultProfileRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetDeviceDefaultProfileResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.SetDeviceDefaultProfileResponse", [
            { no: 1, name: "profile", kind: "message", T: () => DeviceDefaultProfile }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.DeviceDefaultProfile profile */ 1:
                    message.profile = DeviceDefaultProfile.internalBinaryRead(reader, reader.uint32(), options, message.profile);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.DeviceDefaultProfile profile = 1; */
        if (message.profile)
            DeviceDefaultProfile.internalBinaryWrite(message.profile, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.SetDeviceDefaultProfileResponse
 */
export const SetDeviceDefaultProfileResponse = new SetDeviceDefaultProfileResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeviceDefaultProfileRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.GetDeviceDefaultProfileRequest", [
            { no: 1, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.deviceId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string device_id */ 1:
                    message.deviceId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string device_id = 1; */
        if (message.deviceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.deviceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetDeviceDefaultProfileRequest
 */
export const GetDeviceDefaultProfileRequest = new GetDeviceDefaultProfileRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDeviceDefaultProfileResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.GetDeviceDefaultProfileResponse", [
            { no: 1, name: "profile", kind: "message", T: () => DeviceDefaultProfile }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* devices.v1.DeviceDefaultProfile profile */ 1:
                    message.profile = DeviceDefaultProfile.internalBinaryRead(reader, reader.uint32(), options, message.profile);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* devices.v1.DeviceDefaultProfile profile = 1; */
        if (message.profile)
            DeviceDefaultProfile.internalBinaryWrite(message.profile, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.GetDeviceDefaultProfileResponse
 */
export const GetDeviceDefaultProfileResponse = new GetDeviceDefaultProfileResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDeviceDefaultProfileRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteDeviceDefaultProfileRequest", [
            { no: 1, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.deviceId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string device_id */ 1:
                    message.deviceId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string device_id = 1; */
        if (message.deviceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.deviceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteDeviceDefaultProfileRequest
 */
export const DeleteDeviceDefaultProfileRequest = new DeleteDeviceDefaultProfileRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDeviceDefaultProfileResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.DeleteDeviceDefaultProfileResponse", []);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.DeleteDeviceDefaultProfileResponse
 */
export const DeleteDeviceDefaultProfileResponse = new DeleteDeviceDefaultProfileResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDeviceDefaultProfileHistoryRequest$Type extends MessageType {
    constructor() {
        super("devices.v1.ListDeviceDefaultProfileHistoryRequest", [
            { no: 1, name: "device_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.deviceId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string device_id */ 1:
                    message.deviceId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string device_id = 1; */
        if (message.deviceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.deviceId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListDeviceDefaultProfileHistoryRequest
 */
export const ListDeviceDefaultProfileHistoryRequest = new ListDeviceDefaultProfileHistoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListDeviceDefaultProfileHistoryResponse$Type extends MessageType {
    constructor() {
        super("devices.v1.ListDeviceDefaultProfileHistoryResponse", [
            { no: 1, name: "entries", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DeviceDefaultProfileHistoryEntry },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.entries = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated devices.v1.DeviceDefaultProfileHistoryEntry entries */ 1:
                    message.entries.push(DeviceDefaultProfileHistoryEntry.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated devices.v1.DeviceDefaultProfileHistoryEntry entries = 1; */
        for (let i = 0; i < message.entries.length; i++)
            DeviceDefaultProfileHistoryEntry.internalBinaryWrite(message.entries[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message devices.v1.ListDeviceDefaultProfileHistoryResponse
 */
export const ListDeviceDefaultProfileHistoryResponse = new ListDeviceDefaultProfileHistoryResponse$Type();
/**
 * @generated ServiceType for protobuf service devices.v1.DeviceService
 */
export const DeviceService = new ServiceType("devices.v1.DeviceService", [
    { name: "CreateDevice", options: { "google.api.http": { post: "/v1/devices", body: "*" } }, I: CreateDeviceRequest, O: CreateDeviceResponse },
    { name: "GetDevice", options: { "google.api.http": { get: "/v1/devices/{id}" } }, I: GetDeviceRequest, O: GetDeviceResponse },
    { name: "ListDevices", options: { "google.api.http": { get: "/v1/devices" } }, I: ListDevicesRequest, O: ListDevicesResponse },
    { name: "UpdateDevice", options: { "google.api.http": { put: "/v1/devices/{id}", body: "device" } }, I: UpdateDeviceRequest, O: UpdateDeviceResponse },
    { name: "DeleteDevice", options: { "google.api.http": { delete: "/v1/devices/{id}" } }, I: DeleteDeviceRequest, O: DeleteDeviceResponse },
    { name: "RestoreDevice", options: { "google.api.http": { post: "/v1/devices/{id}/restore" } }, I: RestoreDeviceRequest, O: RestoreDeviceResponse },
    { name: "GetDeviceEnrichmentData", options: { "google.api.http": { get: "/v1/devices/{device_id}/enrichment" } }, I: GetDeviceEnrichmentDataRequest, O: GetDeviceEnrichmentDataResponse },
    { name: "BatchGetDeviceEnrichmentData", options: { "google.api.http": { post: "/v1/devices:batchEnrichment", body: "*" } }, I: BatchGetDeviceEnrichmentDataRequest, O: BatchGetDeviceEnrichmentDataResponse },
    { name: "SetDeviceDefaultProfile", options: { "google.api.http": { put: "/v1/devices/{device_id}/default-profile", body: "*" } }, I: SetDeviceDefaultProfileRequest, O: SetDeviceDefaultProfileResponse },
    { name: "GetDeviceDefaultProfile", options: { "google.api.http": { get: "/v1/devices/{device_id}/default-profile" } }, I: GetDeviceDefaultProfileRequest, O: GetDeviceDefaultProfileResponse },
    { name: "DeleteDeviceDefaultProfile", options: { "google.api.http": { delete: "/v1/devices/{device_id}/default-profile" } }, I: DeleteDeviceDefaultProfileRequest, O: DeleteDeviceDefaultProfileResponse },
    { name: "ListDeviceDefaultProfileHistory", options: { "google.api.http": { get: "/v1/devices/{device_id}/default-profile/history" } }, I: ListDeviceDefaultProfileHistoryRequest, O: ListDeviceDefaultProfileHistoryResponse },
    { name: "CreateStation", options: { "google.api.http": { post: "/v1/stations", body: "*" } }, I: CreateStationRequest, O: CreateStationResponse },
    { name: "GetStation", options: { "google.api.http": { get: "/v1/stations/{id}" } }, I: GetStationRequest, O: GetStationResponse },
    { name: "ListStations", options: { "google.api.http": { get: "/v1/stations" } }, I: ListStationsRequest, O: ListStationsResponse },
    { name: "UpdateStation", options: {}, I: UpdateStationRequest, O: UpdateStationResponse },
    { name: "DeleteStation", options: {}, I: DeleteStationRequest, O: DeleteStationResponse },
    { name: "CreateEvse", options: {}, I: CreateEvseRequest, O: CreateEvseResponse },
    { name: "GetEvse", options: {}, I: GetEvseRequest, O: GetEvseResponse },
    { name: "ListEvses", options: {}, I: ListEvsesRequest, O: ListEvsesResponse },
    { name: "UpdateEvse", options: {}, I: UpdateEvseRequest, O: UpdateEvseResponse },
    { name: "DeleteEvse", options: {}, I: DeleteEvseRequest, O: DeleteEvseResponse },
    { name: "CreateConnector", options: {}, I: CreateConnectorRequest, O: CreateConnectorResponse },
    { name: "GetConnector", options: {}, I: GetConnectorRequest, O: GetConnectorResponse },
    { name: "ListConnectors", options: {}, I: ListConnectorsRequest, O: ListConnectorsResponse },
    { name: "UpdateConnector", options: {}, I: UpdateConnectorRequest, O: UpdateConnectorResponse },
    { name: "DeleteConnector", options: {}, I: DeleteConnectorRequest, O: DeleteConnectorResponse },
    { name: "CreateStationaryBattery", options: {}, I: CreateStationaryBatteryRequest, O: CreateStationaryBatteryResponse },
    { name: "GetStationaryBattery", options: {}, I: GetStationaryBatteryRequest, O: GetStationaryBatteryResponse },
    { name: "ListStationaryBatteries", options: {}, I: ListStationaryBatteriesRequest, O: ListStationaryBatteriesResponse },
    { name: "UpdateStationaryBattery", options: {}, I: UpdateStationaryBatteryRequest, O: UpdateStationaryBatteryResponse },
    { name: "DeleteStationaryBattery", options: {}, I: DeleteStationaryBatteryRequest, O: DeleteStationaryBatteryResponse },
    { name: "CreateDeviceError", options: {}, I: CreateDeviceErrorRequest, O: CreateDeviceErrorResponse },
    { name: "GetDeviceError", options: {}, I: GetDeviceErrorRequest, O: GetDeviceErrorResponse },
    { name: "ListDeviceErrors", options: {}, I: ListDeviceErrorsRequest, O: ListDeviceErrorsResponse },
    { name: "ResolveDeviceError", options: {}, I: ResolveDeviceErrorRequest, O: ResolveDeviceErrorResponse }
]);
/**
 * @generated ServiceType for protobuf service devices.v1.DeviceModelService
 */
export const DeviceModelService = new ServiceType("devices.v1.DeviceModelService", [
    { name: "CreateStationModel", options: {}, I: CreateStationModelRequest, O: CreateStationModelResponse },
    { name: "GetStationModel", options: {}, I: GetStationModelRequest, O: GetStationModelResponse },
    { name: "ListStationModels", options: {}, I: ListStationModelsRequest, O: ListStationModelsResponse },
    { name: "UpdateStationModel", options: {}, I: UpdateStationModelRequest, O: UpdateStationModelResponse },
    { name: "DeleteStationModel", options: {}, I: DeleteStationModelRequest, O: DeleteStationModelResponse },
    { name: "CreateEvseModel", options: {}, I: CreateEvseModelRequest, O: CreateEvseModelResponse },
    { name: "GetEvseModel", options: {}, I: GetEvseModelRequest, O: GetEvseModelResponse },
    { name: "ListEvseModels", options: {}, I: ListEvseModelsRequest, O: ListEvseModelsResponse },
    { name: "UpdateEvseModel", options: {}, I: UpdateEvseModelRequest, O: UpdateEvseModelResponse },
    { name: "DeleteEvseModel", options: {}, I: DeleteEvseModelRequest, O: DeleteEvseModelResponse },
    { name: "CreateConnectorModel", options: {}, I: CreateConnectorModelRequest, O: CreateConnectorModelResponse },
    { name: "GetConnectorModel", options: {}, I: GetConnectorModelRequest, O: GetConnectorModelResponse },
    { name: "ListConnectorModels", options: {}, I: ListConnectorModelsRequest, O: ListConnectorModelsResponse },
    { name: "UpdateConnectorModel", options: {}, I: UpdateConnectorModelRequest, O: UpdateConnectorModelResponse },
    { name: "DeleteConnectorModel", options: {}, I: DeleteConnectorModelRequest, O: DeleteConnectorModelResponse },
    { name: "CreateStationBatteryModel", options: {}, I: CreateStationBatteryModelRequest, O: CreateStationBatteryModelResponse },
    { name: "GetStationBatteryModel", options: {}, I: GetStationBatteryModelRequest, O: GetStationBatteryModelResponse },
    { name: "ListStationBatteryModels", options: {}, I: ListStationBatteryModelsRequest, O: ListStationBatteryModelsResponse },
    { name: "UpdateStationBatteryModel", options: {}, I: UpdateStationBatteryModelRequest, O: UpdateStationBatteryModelResponse },
    { name: "DeleteStationBatteryModel", options: {}, I: DeleteStationBatteryModelRequest, O: DeleteStationBatteryModelResponse },
    { name: "CreateCommunicationProtocol", options: {}, I: CreateCommunicationProtocolRequest, O: CreateCommunicationProtocolResponse },
    { name: "UpdateCommunicationProtocol", options: {}, I: UpdateCommunicationProtocolRequest, O: UpdateCommunicationProtocolResponse },
    { name: "ListCommunicationProtocols", options: {}, I: ListCommunicationProtocolsRequest, O: ListCommunicationProtocolsResponse },
    { name: "DeleteCommunicationProtocol", options: {}, I: DeleteCommunicationProtocolRequest, O: DeleteCommunicationProtocolResponse },
    { name: "CreateDeviceErrorType", options: {}, I: CreateDeviceErrorTypeRequest, O: CreateDeviceErrorTypeResponse },
    { name: "GetDeviceErrorType", options: {}, I: GetDeviceErrorTypeRequest, O: GetDeviceErrorTypeResponse },
    { name: "ListDeviceErrorTypes", options: {}, I: ListDeviceErrorTypesRequest, O: ListDeviceErrorTypesResponse },
    { name: "UpdateDeviceErrorType", options: {}, I: UpdateDeviceErrorTypeRequest, O: UpdateDeviceErrorTypeResponse },
    { name: "DeleteDeviceErrorType", options: {}, I: DeleteDeviceErrorTypeRequest, O: DeleteDeviceErrorTypeResponse },
    { name: "CreateControlSignalType", options: {}, I: CreateControlSignalTypeRequest, O: CreateControlSignalTypeResponse },
    { name: "ListControlSignalTypes", options: {}, I: ListControlSignalTypesRequest, O: ListControlSignalTypesResponse },
    { name: "UpdateControlSignalType", options: {}, I: UpdateControlSignalTypeRequest, O: UpdateControlSignalTypeResponse },
    { name: "DeleteControlSignalType", options: {}, I: DeleteControlSignalTypeRequest, O: DeleteControlSignalTypeResponse }
]);
//# sourceMappingURL=service.js.map